// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UnauthenticatedRouteImport } from './routes/_unauthenticated'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as UnauthenticatedVerifyEmailRouteImport } from './routes/_unauthenticated/verify-email'
import { Route as UnauthenticatedSignupRouteImport } from './routes/_unauthenticated/signup'
import { Route as UnauthenticatedResetPasswordRouteImport } from './routes/_unauthenticated/reset-password'
import { Route as UnauthenticatedLoginRouteImport } from './routes/_unauthenticated/login'
import { Route as UnauthenticatedForgotPasswordRouteImport } from './routes/_unauthenticated/forgot-password'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedTournamentsRouteImport } from './routes/_authenticated/tournaments'
import { Route as AuthenticatedPlayersRouteImport } from './routes/_authenticated/players'
import { Route as AuthenticatedDiscoverRouteImport } from './routes/_authenticated/discover'
import { Route as AuthenticatedUsernameRouteImport } from './routes/_authenticated/$username'
import { Route as AuthenticatedVenuesIndexRouteImport } from './routes/_authenticated/venues/index'
import { Route as AuthenticatedFeedIndexRouteImport } from './routes/_authenticated/feed/index'
import { Route as AuthenticatedVenuesNewRouteImport } from './routes/_authenticated/venues/new'
import { Route as AuthenticatedVenuesIdRouteImport } from './routes/_authenticated/venues/$id'
import { Route as AuthenticatedTournamentsIndexRouteImport } from './routes/_authenticated/tournaments/index'
import { Route as AuthenticatedTournamentsNewRouteImport } from './routes/_authenticated/tournaments/new'
import { Route as AuthenticatedTournamentsIdRouteImport } from './routes/_authenticated/tournaments/$id'
import { Route as AuthenticatedPlayersIndexRouteImport } from './routes/_authenticated/players/index'
import { Route as AuthenticatedPlayersIdRouteImport } from './routes/_authenticated/players/$id'
import { Route as ApiAuthSplatSplatRouteImport } from './routes/api/auth/$/$'

const UnauthenticatedRoute = UnauthenticatedRouteImport.update({
            id: '/_unauthenticated',getParentRoute: () => rootRouteImport
          })
const AuthenticatedRoute = AuthenticatedRouteImport.update({
            id: '/_authenticated',getParentRoute: () => rootRouteImport
          })
const UnauthenticatedVerifyEmailRoute = UnauthenticatedVerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => UnauthenticatedRoute
          })
const UnauthenticatedSignupRoute = UnauthenticatedSignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => UnauthenticatedRoute
          })
const UnauthenticatedResetPasswordRoute = UnauthenticatedResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => UnauthenticatedRoute
          })
const UnauthenticatedLoginRoute = UnauthenticatedLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => UnauthenticatedRoute
          })
const UnauthenticatedForgotPasswordRoute = UnauthenticatedForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => UnauthenticatedRoute
          })
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTournamentsRoute = AuthenticatedTournamentsRouteImport.update({
            id: '/tournaments',path: '/tournaments',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedPlayersRoute = AuthenticatedPlayersRouteImport.update({
            id: '/players',path: '/players',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedDiscoverRoute = AuthenticatedDiscoverRouteImport.update({
            id: '/discover',path: '/discover',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedUsernameRoute = AuthenticatedUsernameRouteImport.update({
            id: '/$username',path: '/$username',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedVenuesIndexRoute = AuthenticatedVenuesIndexRouteImport.update({
            id: '/venues/',path: '/venues/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedFeedIndexRoute = AuthenticatedFeedIndexRouteImport.update({
            id: '/feed/',path: '/feed/',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedVenuesNewRoute = AuthenticatedVenuesNewRouteImport.update({
            id: '/venues/new',path: '/venues/new',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedVenuesIdRoute = AuthenticatedVenuesIdRouteImport.update({
            id: '/venues/$id',path: '/venues/$id',getParentRoute: () => AuthenticatedRoute
          })
const AuthenticatedTournamentsIndexRoute = AuthenticatedTournamentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedTournamentsRoute
          })
const AuthenticatedTournamentsNewRoute = AuthenticatedTournamentsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AuthenticatedTournamentsRoute
          })
const AuthenticatedTournamentsIdRoute = AuthenticatedTournamentsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedTournamentsRoute
          })
const AuthenticatedPlayersIndexRoute = AuthenticatedPlayersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AuthenticatedPlayersRoute
          })
const AuthenticatedPlayersIdRoute = AuthenticatedPlayersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AuthenticatedPlayersRoute
          })
const ApiAuthSplatSplatRoute = ApiAuthSplatSplatRouteImport.update({
            id: '/api/auth/$/$',path: '/api/auth/$/$',getParentRoute: () => rootRouteImport
          })





const AuthenticatedPlayersRouteChildren = {
  AuthenticatedPlayersIdRoute: AuthenticatedPlayersIdRoute,AuthenticatedPlayersIndexRoute: AuthenticatedPlayersIndexRoute
}

const AuthenticatedPlayersRouteWithChildren = AuthenticatedPlayersRoute._addFileChildren(AuthenticatedPlayersRouteChildren)




const AuthenticatedTournamentsRouteChildren = {
  AuthenticatedTournamentsIdRoute: AuthenticatedTournamentsIdRoute,AuthenticatedTournamentsNewRoute: AuthenticatedTournamentsNewRoute,AuthenticatedTournamentsIndexRoute: AuthenticatedTournamentsIndexRoute
}

const AuthenticatedTournamentsRouteWithChildren = AuthenticatedTournamentsRoute._addFileChildren(AuthenticatedTournamentsRouteChildren)



const AuthenticatedRouteChildren = {
  AuthenticatedUsernameRoute: AuthenticatedUsernameRoute,AuthenticatedDiscoverRoute: AuthenticatedDiscoverRoute,AuthenticatedPlayersRoute: AuthenticatedPlayersRouteWithChildren,AuthenticatedTournamentsRoute: AuthenticatedTournamentsRouteWithChildren,AuthenticatedIndexRoute: AuthenticatedIndexRoute,AuthenticatedVenuesIdRoute: AuthenticatedVenuesIdRoute,AuthenticatedVenuesNewRoute: AuthenticatedVenuesNewRoute,AuthenticatedFeedIndexRoute: AuthenticatedFeedIndexRoute,AuthenticatedVenuesIndexRoute: AuthenticatedVenuesIndexRoute
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(AuthenticatedRouteChildren)




const UnauthenticatedRouteChildren = {
  UnauthenticatedForgotPasswordRoute: UnauthenticatedForgotPasswordRoute,UnauthenticatedLoginRoute: UnauthenticatedLoginRoute,UnauthenticatedResetPasswordRoute: UnauthenticatedResetPasswordRoute,UnauthenticatedSignupRoute: UnauthenticatedSignupRoute,UnauthenticatedVerifyEmailRoute: UnauthenticatedVerifyEmailRoute
}

const UnauthenticatedRouteWithChildren = UnauthenticatedRoute._addFileChildren(UnauthenticatedRouteChildren)

const rootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,UnauthenticatedRoute: UnauthenticatedRouteWithChildren,ApiAuthSplatSplatRoute: ApiAuthSplatSplatRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)